import React from 'react';
import { Box, Button, CircularProgress, useTheme } from '@mui/material';
import { FaOptionIcon } from '@europrocurement/l2d-icons';

export type DossierFormaliteProcessesFooterProps = {
    needsValidation: boolean;
    canAddFormality: boolean;
    canPublish: boolean;
    publishProcessing: boolean;
    onNavigateToValidation: () => void;
    onPublish: () => void;
    onAddFormality: () => void;
};

const DossierFormaliteProcessesFooter: React.FunctionComponent<DossierFormaliteProcessesFooterProps> =
    function (props) {
        const {
            needsValidation,
            canAddFormality,
            canPublish,
            publishProcessing,
            onNavigateToValidation: handleNavigateToValidation,
            onPublish: handlePublish,
            onAddFormality: handleAddFormality,
        } = props;

        const { palette } = useTheme();

        const wrapperSx = {
            display: 'flex',
            width: '100%',
            alignItems: 'center',
            paddingTop: '16px',
        };

        const endWrapperSx = {
            display: 'flex',
            alignItems: 'center',
            columnGap: '16px',
            marginLeft: 'auto',
            marginRight: 0,
        };

        const defaultBtnSx = {
            fontWeight: 500,
            padding: '8px 20px',
        };

        const coloredBtnSx = {
            ...defaultBtnSx,
            backgroundColor: '#177BC2',
            color: '#fff',
            ':hover': {
                backgroundColor: 'primary.main',
            },
        };

        const publishButtonSx = {
            ...coloredBtnSx,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            columnGap: '8px',
            ':disabled': {
                backgroundColor: palette.grey[200],
            },
        };

        const textBtnSx = {
            ...defaultBtnSx,
            display: 'flex',
            columnGap: '4px',
            alignItems: 'center',
            color: 'primary.dark',
            ':hover': {
                color: 'primary.main',
            },
        };

        const addBtnIconSx = {
            lineHeight: 1,
            color: 'inherit',
        };

        return (
            <Box sx={wrapperSx}>
                {canAddFormality && (
                    <Button
                        onClick={handleAddFormality}
                        sx={textBtnSx}
                        variant="text"
                        key="add-formality-btn"
                    >
                        <FaOptionIcon
                            icon={['fas', 'plus']}
                            sx={addBtnIconSx}
                        />
                        Ajouter une formalité
                    </Button>
                )}
                {(canPublish || needsValidation) && (
                    <Box sx={endWrapperSx}>
                        {canPublish && (
                            <Button
                                onClick={handlePublish}
                                sx={publishButtonSx}
                                key="publish-btn"
                                disabled={publishProcessing}
                            >
                                {publishProcessing && <CircularProgress size="16px" />}
                                Déposer
                            </Button>
                        )}
                        {needsValidation && (
                            <Button
                                onClick={handleNavigateToValidation}
                                sx={coloredBtnSx}
                                key="validate-btn"
                            >
                                Vérifier les informations
                            </Button>
                        )}
                    </Box>
                )}
            </Box>
        );
    };

export default DossierFormaliteProcessesFooter;
